import ElForm from './src/form';

/* istanbul ignore next */
ElForm.install = function(Vue) {
  Vue.component(ElForm.name, ElForm);
};

export default ElForm;



// WEBPACK FOOTER //
// ./src/components/element/packages/form/index.js